import React from 'react';

function ArrowUpRotate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 35 35"
      style={{ transform: [{ rotate: '47deg' }] }}
    >
      <path
        fill="#fff"
        d="M23.15 20.443l.21-6.07a2 2 0 00-1.923-2.064l-6.07-.223a1 1 0 10-.064 2l4.65.165-8.05 7.497a1 1 0 101.363 1.463l8.05-7.496-.165 4.65a1.001 1.001 0 002 .078z"
      ></path>
    </svg>
  );
}

export default ArrowUpRotate;
